<div #trigger class="ui-partner-array-input-container ui-secondary" (click)="eventOpenOptions()">
    @if (searching) {
        <div class="ui-partner-array-input-items">
            <div class="ui-badge" skeletonLoaderPipe = "rect">
                Carregando...
            </div>
        </div>
    } @else {
        <div class="ui-partner-array-input-placeholder">{{ placeholder }}</div>
        <div class="ui-partner-array-input-items" *ngIf="selectedPartners.size">
            @for(partner of selectedPartners; track partner._id) {
                <div class="ui-badge">
                    <span>{{ partner.name }}</span>
                    <i class="ui-icon uii-trash-alt" (click)="eventRemovePartner(partner)"></i>
                </div>
            }
        </div>
    }
</div>

<ng-template #dropdownTemplate>
    <div class="ui-select-menu">
        <div class="ui-field ui-secondary ui-field-without-border">
            <i class="ui-icon uii-search"></i>
            <input type="text" class="ui-select-menu-search-input" placeholder="Buscar parceiro..." (input)="eventPartnerFilterChange($event)"/>
        </div>

        <div class="ui-select-options" [ngClass]="{ 'ui-select-searching-options': searching }">
            @for (partner of partners; track partner._id) {
                <div class="ui-select-option" (click)="eventPartnerChanged(partner)" [ngClass] = "{'ui-badge-active': hasPartner(partner)}">
                    <div class="ui-select-icon">
                        <img [src] = "partner.logoSrc" width="100%" height="100%">
                    </div>
                    <div>
                        <div class="ui-title">
                            {{ partner.name }}
                        </div>
                        <span class="ui-sub-title">
                            {{ partner.detail.document.number | mask: partner.detail.document.number.length ? '000.000.000-00' : '99.999.999/9999-99'}}
                        </span>
                    </div>
                </div>
            }
            @if (partners.length === 0) {
                <div class="ui-empty-container">
                    Nenhum parceiro encontrado
                </div>
            }
        </div>
    </div>
</ng-template>
